import React from "react"
import styled, { css } from "styled-components"
import { Container } from "reactstrap"
import { media } from "utils/Media"

const ContainerMax = styled(({ noPadding, maxWidth, ...props }) => (
    <Container {...props}>{props.children}</Container>
))`
    max-width: ${props => props.theme.sizes.xxl};

    ${props => props.maxWidth && css`
        max-width: ${props => props.maxWidth}px;
    `}

    ${props => props.noPadding && css`
        padding: 0;
    `}

    ${props => props.noPaddingMd && css`
        padding: 0;
        @media ${media.md} {
            padding-right: ${props => props.theme.bootstrapGutterWidth};
            padding-left: ${props => props.theme.bootstrapGutterWidth};
        }
    `}
`;

export default ContainerMax